import dynamic from "next/dynamic";
import { Builder } from "@builder.io/react";
import { toolkitColors } from "@/utils/constants";

const Dashhudson= dynamic(async () => {
  return (await import("./Dashhudson")).default;
});

Builder.registerComponent(Dashhudson, {
  name: "Dashhudson",
  inputs: [
    {
      name: "data_gallery_id",
      type: "number",
      helperText: "Galary id*",
    },
    {
      name: "data_row_size",
      type: "number",
      helperText: "Row size",
    },
    {
      name: "data_gap_size",
      type: "number",
      helperText: "Gap size",
    },
    {
      name: "data_mobile_row_size",
      type: "number",
      helperText: "Mobile row size",
    },
    {
      name: "data_autoplay",
      type: "string",
      helperText: "Data autoplay",
    },
    {
      name: "data_mobile_gap_size",
      type: "number",
      helperText: "Mobile gap size",
    },
    {
      name: "data_call_to_action",
      type: "string",
      helperText: "Data CTA (If present)",
    },
  ]
});
